// SPDX-License-Identifier: AGPL-3.0-or-later

export function hostedImageUrl(name: string): string {
	return `https://omnivybe.com.tr/static/img/${name}`;
}
